import { Component } from "@angular/core";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { SimpleModalComponent } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.component";
import { take } from "rxjs/operators";
@Component({
  selector: "ngx-splash-form",
  templateUrl: "./splash-form.component.html",
  styleUrls: ["./splash-form.component.scss"],
})
export class SplashFormComponent extends SimpleModalComponent<ConfirmModel, boolean> implements ConfirmModel {
  hasCancelButton?: boolean;
  title: string;
  errorMessage: string;
  isLoading: boolean = true;

  close() {
    this.result = false;

    this.closeModal();
  }
}
export interface ConfirmModel {
  title: string;
  errorMessage: string;
  hasCancelButton?: boolean;
}
